import { GreenOnlyInterval } from '../../common/redux/api/web-api'

export function getGreenChargingInterval(greenOnlyInterval: GreenOnlyInterval, reverse: boolean): string {
    const { startHour, startMinute, endHour, endMinute } = greenOnlyInterval
    const start = startHour && startHour.toString().padStart(2, '0') + ':' + startMinute?.toString().padStart(2, '0')
    const end = endHour && endHour.toString().padStart(2, '0') + ':' + endMinute?.toString().padStart(2, '0')

    if (reverse) {
        return end + '-' + start
    }
    return start + '-' + end
}
